/* Stone Haus paver buy box — Sep 29, 2026 (Sep 30: edge pieces can be entered in lm or pieces)
   Markup: snippets/sh-paver-buybox.liquid. Styles: sh-cladding-buybox.css + sh-paver-buybox.css. */
(() => {
  if (window.__shpBuyboxBooted) return;
  window.__shpBuyboxBooted = true;

  const toNumber = (input) => {
    if (!input) return 0;
    const value = parseFloat(String(input.value || '').replace(',', '.'));
    return Number.isFinite(value) && value > 0 ? value : 0;
  };
  // Round to 3dp first so floating point noise (22.000000001) doesn't bump a whole unit.
  const ceilQty = (value) => Math.ceil(Math.round(value * 1000) / 1000);
  const trimNum = (value) => String(Math.round(value * 100) / 100);

  const money = (cents, currency) => {
    const amount = Math.round(cents) / 100;
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: currency || 'AUD',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(amount % 1 === 0 ? 0 : 2);
    }
  };

  const sydneyWeekday = () => {
    try {
      return new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', weekday: 'short' }).format(new Date());
    } catch (error) {
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][new Date().getDay()];
    }
  };

  function init(root) {
    if (!root || root.dataset.shpReady === 'true') return;
    root.dataset.shpReady = 'true';

    const q = (selector) => root.querySelector(selector);
    const qa = (selector) => Array.from(root.querySelectorAll(selector));

    let data = {};
    try { data = JSON.parse(q('[data-shp-data]').textContent); } catch (error) { data = {}; }
    const paving = Array.isArray(data.paving) ? data.paving : [];
    const edges = Array.isArray(data.edges) ? data.edges : [];
    const edgeUnit = data.edgeUnit === 'piece' ? 'piece' : 'lm';
    const sealer = data.sealer && data.sealer.available ? data.sealer : null;

    const waste = Number(root.dataset.waste) || 0;
    const afterpayLimit = Number(root.dataset.afterpayLimit) || 4000;
    const currency = root.dataset.currency || 'AUD';
    const title = root.dataset.title || 'this stone';

    const el = {
      options: qa('[data-shp-option]'),
      hint: q('[data-shp-hint]'),
      price: q('[data-shp-price]'),
      stock: q('[data-shp-stock]'),
      tabs: qa('[data-shc-tab]'),
      panels: qa('[data-shc-panel]'),
      area: q('[data-shp-area]'),
      length: q('[data-shp-length]'),
      width: q('[data-shp-width]'),
      wasteToggle: q('[data-shp-waste-toggle]'),
      edgeToggle: q('[data-shp-edge-toggle]'),
      edgeFields: q('[data-shp-edge-fields]'),
      edgeOptions: qa('[data-shp-edge-option]'),
      edgeLm: q('[data-shp-edge-lm]'),
      edgePcs: q('[data-shp-edge-pcs]'),
      edgeUnits: qa('[data-shp-edge-unit]'),
      edgeBy: qa('[data-shp-edge-by]'),
      edgePieces: q('[data-shp-edge-pieces]'),
      sealerToggle: q('[data-shp-sealer-toggle]'),
      sealerFields: q('[data-shp-sealer-fields]'),
      sealerQty: q('[data-shp-sealer-qty]'),
      summary: q('[data-shp-summary]'),
      paveRow: q('[data-shp-pave-row]'),
      paveLabel: q('[data-shp-pave-label]'),
      paveQty: q('[data-shp-pave-qty]'),
      paveCost: q('[data-shp-pave-cost]'),
      pieces: q('[data-shp-pieces]'),
      edgeRow: q('[data-shp-edge-row]'),
      edgeLabel: q('[data-shp-edge-label]'),
      edgeQty: q('[data-shp-edge-qty]'),
      edgeCost: q('[data-shp-edge-cost]'),
      sealerRow: q('[data-shp-sealer-row]'),
      sealerQtyOut: q('[data-shp-sealer-out]'),
      sealerCost: q('[data-shp-sealer-cost]'),
      total: q('[data-shp-total]'),
      afterpay: q('[data-shp-afterpay]'),
      atc: q('[data-shp-atc]'),
      atcLabel: q('[data-shp-atc-label]'),
      buyNow: q('[data-shp-buynow]'),
      error: q('[data-shp-error]'),
      quote: q('[data-shp-quote]'),
      sample: q('[data-shp-sample]'),
      exampleToggle: q('[data-shp-example-toggle]'),
      ready: q('[data-shp-ready]')
    };

    const byId = (list, id) => list.find((item) => String(item.id) === String(id)) || null;
    let current = byId(paving, root.dataset.selected) || paving.find((item) => item.available) || paving[0] || null;
    let currentEdge = edges.find((item) => item.available) || edges[0] || null;
    let mode = 'area';
    let edgeBy = 'lm'; // how the customer enters edges: 'lm' or 'pieces'
    let state = { paveQty: 0, edgeQty: 0, sealerQty: 0, total: 0 };
    const afterpayDefault = el.afterpay ? el.afterpay.innerHTML : '';

    const perM2 = (option) => (option && option.w > 0 && option.h > 0 ? 1000000 / (option.w * option.h) : 0);

    /* ---------- Format (thickness) choice ---------- */
    const showOption = () => {
      el.options.forEach((button) => {
        const active = !!current && String(button.dataset.shpOption) === String(current.id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      if (!current) return;
      if (el.price) el.price.textContent = money(current.price, currency);
      if (el.stock) {
        el.stock.textContent = current.available ? 'In stock' : 'Out of stock';
        const badge = el.stock.closest('.shc-stock') || el.stock;
        badge.classList.toggle('shc-stock--out', !current.available);
      }
      if (el.hint) {
        const parts = [];
        if (current.hint) parts.push(current.hint);
        const pieces = perM2(current);
        if (pieces) parts.push('About ' + trimNum(Math.round(pieces * 10) / 10) + ' pavers per m².');
        el.hint.textContent = parts.join(' ');
        el.hint.hidden = !parts.length;
      }
    };

    const selectOption = (id, focus) => {
      const next = byId(paving, id);
      if (!next) return;
      current = next;
      showOption();
      if (focus) {
        const button = el.options.find((item) => String(item.dataset.shpOption) === String(id));
        if (button) button.focus();
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (error) {}
      update();
    };

    el.options.forEach((button, index) => {
      button.addEventListener('click', () => selectOption(button.dataset.shpOption));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const nextIndex = (index + (event.key === 'ArrowRight' ? 1 : -1) + el.options.length) % el.options.length;
        selectOption(el.options[nextIndex].dataset.shpOption, true);
      });
    });

    /* ---------- Tabs ---------- */
    const setMode = (next, focus) => {
      if (next === mode) return;
      // Carry the measurement across so switching tabs never loses work.
      if (next === 'area' && el.area && !toNumber(el.area)) {
        const sized = toNumber(el.length) * toNumber(el.width);
        if (sized > 0) el.area.value = trimNum(sized);
      }
      mode = next;
      el.tabs.forEach((tab) => {
        const active = tab.dataset.shcTab === mode;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      el.panels.forEach((panel) => { panel.hidden = panel.dataset.shcPanel !== mode; });
      update();
    };

    el.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setMode(tab.dataset.shcTab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const nextIndex = (index + (event.key === 'ArrowRight' ? 1 : -1) + el.tabs.length) % el.tabs.length;
        setMode(el.tabs[nextIndex].dataset.shcTab, true);
      });
    });

    /* ---------- Edge pieces ---------- */
    const showEdge = () => {
      el.edgeOptions.forEach((button) => {
        const active = !!currentEdge && String(button.dataset.shpEdgeOption) === String(currentEdge.id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', String(active));
        button.tabIndex = active ? 0 : -1;
      });
    };
    el.edgeOptions.forEach((button) => {
      button.addEventListener('click', () => {
        const next = byId(edges, button.dataset.shpEdgeOption);
        if (!next || !next.available) return;
        currentEdge = next;
        showEdge();
        update();
      });
    });

    const edgeInput = () => (edgeBy === 'pieces' && el.edgePcs ? el.edgePcs : el.edgeLm);

    // Lineal metres or pieces. Switching carries the current figure across, so the order doesn't
    // change. A box that already agrees with it is left alone (21 lm -> 35 pcs -> back to 21 lm).
    const setEdgeBy = (next, focus) => {
      if (next !== 'lm' && next !== 'pieces') return;
      if (next === 'pieces' && !el.edgePcs) return;
      const len = currentEdge && currentEdge.len > 0 ? currentEdge.len : 0;
      if (next !== edgeBy && len && el.edgeLm && el.edgePcs) {
        const lmQty = edgeCount(toNumber(el.edgeLm));
        const pcsQty = ceilQty(toNumber(el.edgePcs));
        if (next === 'pieces' && lmQty > 0 && pcsQty !== lmQty) {
          el.edgePcs.value = String(lmQty);
        } else if (next === 'lm' && pcsQty > 0 && lmQty !== pcsQty) {
          el.edgeLm.value = trimNum((pcsQty * len) / 1000);
        }
      }
      edgeBy = next;
      el.edgeUnits.forEach((button) => {
        const active = button.dataset.shpEdgeUnit === edgeBy;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && focus === 'button') button.focus();
      });
      el.edgeBy.forEach((field) => { field.hidden = field.dataset.shpEdgeBy !== edgeBy; });
      if (focus === 'input' && edgeInput()) edgeInput().focus();
      update();
    };
    el.edgeUnits.forEach((button, index) => {
      button.addEventListener('click', () => setEdgeBy(button.dataset.shpEdgeUnit, 'input'));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        const nextButton = el.edgeUnits[(index + step + el.edgeUnits.length) % el.edgeUnits.length];
        setEdgeBy(nextButton.dataset.shpEdgeUnit, 'button');
      });
    });

    if (el.edgeToggle) {
      el.edgeToggle.addEventListener('change', () => {
        if (el.edgeFields) el.edgeFields.hidden = !el.edgeToggle.checked;
        const input = edgeInput();
        if (el.edgeToggle.checked && input && !toNumber(input)) input.focus();
        update();
      });
    }

    /* ---------- Sealer ---------- */
    if (el.sealerToggle) {
      el.sealerToggle.addEventListener('change', () => {
        if (el.sealerFields) el.sealerFields.hidden = !el.sealerToggle.checked;
        update();
      });
    }

    /* ---------- Calculation ---------- */
    const edgeCount = (lm) => {
      if (!(lm > 0) || !currentEdge) return 0;
      if (edgeUnit === 'piece' && currentEdge.len > 0) return ceilQty((lm * 1000) / currentEdge.len);
      return ceilQty(lm);
    };

    const calculate = () => {
      const area = mode === 'area'
        ? toNumber(el.area)
        : toNumber(el.length) * toNumber(el.width);
      const wasteOn = !!(el.wasteToggle && el.wasteToggle.checked && waste > 0);
      const paveQty = current && current.available && area > 0 ? ceilQty(area * (wasteOn ? 1 + waste / 100 : 1)) : 0;
      const pieces = paveQty && perM2(current) ? Math.ceil(paveQty * perM2(current)) : 0;

      let edgeLm = 0;
      let edgeQty = 0;
      let edgePcsRounded = false;
      if (currentEdge && currentEdge.available && el.edgeToggle && el.edgeToggle.checked) {
        if (edgeBy === 'pieces' && el.edgePcs) {
          const typed = toNumber(el.edgePcs);
          edgeQty = ceilQty(typed);
          edgePcsRounded = edgeQty > 0 && edgeQty !== typed;
          edgeLm = currentEdge.len > 0 ? (edgeQty * currentEdge.len) / 1000 : 0;
        } else {
          edgeLm = toNumber(el.edgeLm);
          edgeQty = edgeCount(edgeLm);
        }
      }

      let sealerQty = 0;
      if (sealer && el.sealerToggle && el.sealerToggle.checked) {
        sealerQty = Math.floor(toNumber(el.sealerQty));
      }

      const paveCost = current ? paveQty * current.price : 0;
      const edgeCost = currentEdge ? edgeQty * currentEdge.price : 0;
      const sealerCost = sealer ? sealerQty * sealer.price : 0;
      return {
        area, wasteOn, paveQty, pieces, paveCost,
        edgeBy, edgeLm, edgeQty, edgeCost, edgePcsRounded,
        sealerQty, sealerCost,
        total: paveCost + edgeCost + sealerCost
      };
    };

    const cartItems = (r) => {
      const items = [];
      if (r.paveQty > 0 && current) items.push({ id: current.id, quantity: r.paveQty });
      if (r.edgeQty > 0 && currentEdge) items.push({ id: currentEdge.id, quantity: r.edgeQty });
      if (r.sealerQty > 0 && sealer) items.push({ id: sealer.id, quantity: r.sealerQty });
      return items;
    };

    const permalink = () => {
      const parts = cartItems(state).map((item) => item.id + ':' + item.quantity);
      if (!parts.length) return '#';
      const base0 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const base = base0.endsWith('/') ? base0 : base0 + '/';
      const shopPay = el.buyNow && el.buyNow.dataset.shopPay === 'true';
      return base + 'cart/' + parts.join(',') + (shopPay ? '?payment=shop_pay' : '');
    };

    const edgeQtyText = (qty) => (edgeUnit === 'piece' ? qty + (qty === 1 ? ' piece' : ' pieces') : qty + ' lm');

    const update = () => {
      const r = calculate();
      state = r;
      const soldOut = !current || !current.available;
      const hasQty = r.paveQty > 0 || r.edgeQty > 0 || r.sealerQty > 0;

      if (el.edgePieces) {
        let hint = '';
        if (edgeUnit === 'piece' && r.edgeQty > 0 && currentEdge) {
          if (r.edgeBy === 'pieces') {
            if (currentEdge.len > 0) hint = edgeQtyText(r.edgeQty) + ' × ' + currentEdge.len + ' mm covers about ' + trimNum(r.edgeLm) + ' lm of edge';
            if (r.edgePcsRounded) hint = (hint ? hint + ' · ' : '') + 'rounded up to whole pieces';
            if (hint) hint += '.';
          } else if (currentEdge.len > 0) {
            hint = '= ' + edgeQtyText(r.edgeQty) + ' of ' + currentEdge.len + ' mm, rounded up';
          }
        }
        el.edgePieces.hidden = !hint;
        el.edgePieces.textContent = hint;
      }

      if (el.summary) el.summary.hidden = !(r.paveQty > 0 || r.edgeQty > 0 || r.sealerQty > 0);
      if (el.paveRow) el.paveRow.hidden = !(r.paveQty > 0);
      if (el.paveLabel) {
        el.paveLabel.textContent = 'Paving · ' + (current ? current.label + ' · ' : '') + trimNum(r.area) + ' m²' +
          (r.wasteOn ? ' + ' + waste + '%' : '') + ', rounded up';
      }
      if (el.paveQty) el.paveQty.textContent = r.paveQty + ' m²';
      if (el.paveCost) el.paveCost.textContent = money(r.paveCost, currency);
      if (el.pieces) {
        el.pieces.hidden = !r.pieces;
        el.pieces.textContent = r.pieces && current
          ? 'About ' + r.pieces + ' pavers of ' + current.w + ' × ' + current.h + ' mm.'
          : '';
      }

      if (el.edgeRow) {
        el.edgeRow.hidden = !(r.edgeQty > 0);
        if (el.edgeLabel) {
          el.edgeLabel.textContent = 'Edge pieces · ' + (currentEdge ? currentEdge.label : '') +
            (r.edgeBy === 'pieces'
              ? (currentEdge && currentEdge.len > 0 ? ' · ' + currentEdge.len + ' mm each' : '')
              : ' · ' + trimNum(r.edgeLm) + ' lm');
        }
        if (el.edgeQty) el.edgeQty.textContent = edgeQtyText(r.edgeQty);
        if (el.edgeCost) el.edgeCost.textContent = money(r.edgeCost, currency);
      }

      if (el.sealerRow) {
        el.sealerRow.hidden = !(r.sealerQty > 0);
        if (el.sealerQtyOut) el.sealerQtyOut.textContent = r.sealerQty + ' × 4 L';
        if (el.sealerCost) el.sealerCost.textContent = money(r.sealerCost, currency);
      }
      if (el.total) el.total.textContent = money(r.total, currency);

      if (el.afterpay) {
        if (!hasQty) {
          el.afterpay.innerHTML = current
            ? 'or 4 payments of <strong>' + money(Math.round(current.price / 4), currency) + '</strong> per m² <span class="shc-dot">·</span> up to ' + money(afterpayLimit * 100, currency)
            : afterpayDefault;
        } else if (r.total / 100 <= afterpayLimit) {
          el.afterpay.innerHTML = 'or 4 payments of <strong>' + money(Math.round(r.total / 4), currency) +
            '</strong> for this order <span class="shc-dot">·</span> up to ' + money(afterpayLimit * 100, currency);
        } else {
          el.afterpay.innerHTML = 'Afterpay is available on orders up to ' + money(afterpayLimit * 100, currency);
        }
      }

      if (el.atc) {
        el.atc.disabled = !hasQty;
        if (soldOut && !hasQty) {
          el.atcLabel.textContent = 'This format is out of stock';
        } else if (!hasQty) {
          el.atcLabel.textContent = el.atc.dataset.defaultLabel || 'Enter your area to see your total';
        } else {
          const parts = [];
          if (r.paveQty) parts.push(r.paveQty + ' m²');
          if (r.edgeQty) parts.push(edgeUnit === 'piece' ? r.edgeQty + ' edge pcs' : r.edgeQty + ' lm edge');
          if (r.sealerQty) parts.push(r.sealerQty === 1 ? 'sealer' : r.sealerQty + ' sealers');
          el.atcLabel.textContent = 'Add ' + parts.join(' + ') + ' to cart · ' + money(r.total, currency);
        }
      }

      if (el.buyNow) {
        el.buyNow.href = permalink();
        el.buyNow.classList.toggle('is-disabled', !hasQty);
        el.buyNow.setAttribute('aria-disabled', String(!hasQty));
      }
      if (el.error) el.error.hidden = true;
    };

    root.addEventListener('input', (event) => {
      if (event.target.matches('input[type="number"]')) update();
    });
    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-shp-waste-toggle]')) update();
    });

    /* ---------- Add to cart ---------- */
    const showError = (message) => {
      if (!el.error) return;
      el.error.textContent = message || 'Something went wrong. Please try again or call us.';
      el.error.hidden = false;
    };

    const addToCart = async () => {
      const r = calculate();
      const items = cartItems(r);
      if (!items.length) return;

      const drawer = document.querySelector('cart-drawer');
      const useDrawer = !!(drawer && drawer.dataset.cartType === 'drawer' && typeof drawer.renderContents === 'function');
      const sections = useDrawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((section) => section.id)
        : [];

      el.atc.disabled = true;
      el.atc.classList.add('is-loading');
      const previousLabel = el.atcLabel.textContent;
      el.atcLabel.textContent = 'Adding…';

      try {
        const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
        const body = { items };
        if (sections.length) {
          body.sections = sections.join(',');
          body.sections_url = window.location.pathname;
        }
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'We could not add that to your cart.');
        }

        try {
          // eslint-disable-next-line no-undef
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shp-buybox', cartData: result });
        } catch (error) {}

        if (useDrawer && result.sections) {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result, !document.body.classList.contains('page-overlay-cart-on'));
          } catch (error) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        el.atcLabel.textContent = 'Added to cart ✓';
        setTimeout(update, 1800);
      } catch (error) {
        el.atcLabel.textContent = previousLabel;
        showError(error.message);
        el.atc.disabled = false;
      } finally {
        el.atc.classList.remove('is-loading');
      }
    };

    if (el.atc) el.atc.addEventListener('click', addToCart);
    if (el.buyNow) {
      el.buyNow.addEventListener('click', (event) => {
        if (el.buyNow.classList.contains('is-disabled')) event.preventDefault();
      });
    }

    /* ---------- Enquiry panel (quote / sample) ---------- */
    const enquiryPanel = () => document.querySelector('[id*="stonehaus_enquiry_panel"]');

    const openEnquiry = (message) => {
      const panel = enquiryPanel();
      if (!panel) {
        window.location.href = '/pages/contact';
        return;
      }
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const box = panel.querySelector('textarea');
      if (!box) return;
      if (!box.value.trim() || box.dataset.shpFilled === 'true') {
        box.value = message;
        box.dataset.shpFilled = 'true';
      }
      setTimeout(() => { try { box.focus({ preventScroll: true }); } catch (error) {} }, 500);
    };

    const quoteMessage = () => {
      const r = calculate();
      const lines = ['Quote request: ' + title];
      if (current) lines.push('Format: ' + current.label + (current.size ? ' (' + current.size + ')' : ''));
      if (r.area) lines.push('Approx. area: ' + trimNum(r.area) + ' m²');
      if (r.edgeQty && currentEdge) {
        lines.push('Edge pieces: ' + currentEdge.label + ', ' + (r.edgeBy === 'pieces'
          ? edgeQtyText(r.edgeQty) + (r.edgeLm ? ' (about ' + trimNum(r.edgeLm) + ' lm)' : '')
          : trimNum(r.edgeLm) + ' lm'));
      }
      if (r.sealerQty) lines.push('Sealer: ' + r.sealerQty + ' × 4 L');
      const postcode = root.querySelector('[data-sh-delivery-postcode]');
      if (postcode && postcode.value.trim()) lines.push('Delivery postcode: ' + postcode.value.trim());
      return lines.join('\n') + '\n';
    };

    if (el.quote) {
      el.quote.addEventListener('click', (event) => {
        event.preventDefault();
        openEnquiry(quoteMessage());
      });
    }
    if (el.sample) {
      el.sample.addEventListener('click', (event) => {
        event.preventDefault();
        openEnquiry('Sample request: ' + title + (current ? ', ' + current.label : '') + '\n');
      });
    }

    // Paver wording for the shared enquiry panel (its template copy is written for cladding).
    if (root.dataset.enquiryText) {
      document.querySelectorAll('[id*="stonehaus_enquiry_panel"] .sh-enq__text').forEach((node) => {
        const p = document.createElement('p');
        p.textContent = root.dataset.enquiryText;
        node.replaceChildren(p);
      });
    }
    if (root.dataset.enquiryPlaceholder) {
      document.querySelectorAll('[id*="stonehaus_enquiry_panel"] textarea').forEach((node) => {
        node.setAttribute('placeholder', root.dataset.enquiryPlaceholder);
      });
    }

    /* ---------- Worked example ---------- */
    if (el.exampleToggle) {
      el.exampleToggle.addEventListener('click', () => {
        const panel = document.getElementById(el.exampleToggle.getAttribute('aria-controls'));
        if (!panel) return;
        panel.hidden = !panel.hidden;
        el.exampleToggle.setAttribute('aria-expanded', String(!panel.hidden));
      });
    }

    /* ---------- Fulfilment options ---------- */
    const options = qa('[data-shp-opt]');
    const syncOptions = () => {
      options.forEach((option) => {
        const radio = option.querySelector('input[type="radio"]');
        option.classList.toggle('is-active', !!(radio && radio.checked));
      });
    };
    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-shp-opt] input[type="radio"]')) syncOptions();
    });
    options.forEach((option) => {
      const radio = option.querySelector('input[type="radio"]');
      option.addEventListener('focusin', (event) => {
        if (radio && !radio.checked && event.target !== radio && option.contains(event.target)) {
          radio.checked = true;
          syncOptions();
        }
      });
      option.addEventListener('click', (event) => {
        if (radio && !radio.checked && !event.target.closest('a, button, input')) {
          radio.checked = true;
          syncOptions();
        }
      });
    });

    const estimator = q('.sh-delivery-estimator');
    if (estimator) {
      const button = estimator.querySelector('[data-sh-delivery-submit]');
      const input = estimator.querySelector('[data-sh-delivery-postcode]');
      if (button) button.textContent = 'Check';
      if (input) input.setAttribute('placeholder', 'Postcode, e.g. 2170');
    }

    if (el.ready) {
      el.ready.textContent = sydneyWeekday() === 'Sat' ? 'Monday' : 'Tomorrow';
    }

    showOption();
    showEdge();
    update();
  }

  const scan = (scope) => {
    (scope || document).querySelectorAll('[data-shp-buybox]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
